import React, { useState } from "react";
import WatchBox from "./watch";
import CampBox from "./camp";
import RankingBox from "./ranking";
import ShopBox from "./shop";
import MessageLogger from "../home/message-logger";
import { motion } from "framer-motion";
import Button from "../../../components/Button";
import { CustomIcon } from "../../../components/Icons";
import { getProfileURL } from "../../../utils/profile-url";
import { useConnector } from "../../connector/context";
import { useDispatch, useSelector } from "react-redux";
import { CloseArenaDialog } from "../../../redux/arena-dialog/action";
import Dialog from "../../../components/Dialog";
import YouTube from "react-youtube";
import { isMobile } from "react-device-detect";
import CircularProgress from "../../../components/CircularProgress";
import { Assets } from "../../../constants/assets";
import { useNavigate } from "react-router-dom";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

type Props = {};

const ArenaDashboard = (props: Props) => {
  const { connector } = useConnector();
  const navigate = useNavigate();
  const { t } = useAppTranslation("battle");
  const [videoDialog, setVideoDialog] = useState(false);
  const userInfo = useSelector((state: any) => state.userInfo);
  const dispatch = useDispatch();
  const boxes = [
    {
      title: t("dashboard.boxes.watch.title"),
      icon: "/assets/images/arena/icons/watch.png",
      description: t("dashboard.boxes.watch.description"),
      link: "/arena/watch",
    },
    {
      title: t("dashboard.boxes.camp.title"),
      icon: "/assets/images/arena/icons/dart.png",
      description: t("dashboard.boxes.camp.description"),
      link: "/barracks?type=camp",
    },
    {
      title: t("dashboard.boxes.leaderboard.title"),
      icon: "/assets/images/icons/cup.png",
      description: t("dashboard.boxes.leaderboard.description"),
      link: "/arena/leader-board/lords",
    },
    {
      title: t("dashboard.boxes.shop.title"),
      icon: Assets.icons.arenaShop,
      description: t("dashboard.boxes.shop.description"),
      link: "/marketplace?type=6",
    },
  ];
  const onFriendlyMatch = () => {
    connector?.hostMatch(
      userInfo.username,
      getProfileURL(userInfo.id, userInfo.photoFile) || ""
    );
  };

  return (
    <div className="arena-dashboard pb-5 pb-md-2 ">
      <MessageLogger />
      {isMobile ? (
        <div className="row">
          {boxes.map((item) => (
            <div
              onClick={() => {
                navigate(item.link);
                dispatch(CloseArenaDialog());
              }}
              className="col-6"
            >
              <div className="mobile-box-arena gap-2">
                <img width={40} height={40} src={item.icon} alt={item.title} />
                <div className="fs-large bold">{item.title}</div>
                <div className=" dark-yellow">{item.description}</div>
              </div>
            </div>
          ))}
          <div
            style={{ marginBottom: isMobile ? -120 : -40 }}
            className="col-12 mt-3 d-flex align-items-center justify-content-between"
          >
            <Button
              onClick={() => {
                onFriendlyMatch();
                dispatch(CloseArenaDialog());
              }}
              variant="wide"
              style={{ height: 53 }}
              size={isMobile ? "small" : "medium"}
              className="bg-100 gap-2  px-3"
            >
              {t("dashboard.actions.friendlyMatch")}
            </Button>
            <Button
              size={isMobile ? "small" : "medium"}
              onClick={() => setVideoDialog(true)}
              style={{ height: 53 }}
              variant="wide"
              className="bg-100 gap-2 px-3 "
            >
              <CustomIcon
                icon="youtube-icon"
                width={20}
                height={15}
                type="svg"
              />
              {t("dashboard.actions.learnArena")}
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{ minHeight: "100%", alignItems: "center" }}
          className="row gap-4 gap-md-0 "
        >
          <div className="col-lg-9">
            <div className="row gap-4 gap-md-0">
              <motion.div
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut", delay: 0 }}
                className="col-lg-6 p-0"
              >
                <WatchBox />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut", delay: 0.1 }}
                className="col-lg-6 p-0"
              >
                <CampBox />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut", delay: 0.15 }}
                className="col-lg-12"
              >
                <ShopBox />
              </motion.div>
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut", delay: 0.2 }}
            className="col-lg-3 p-0 pt-1"
          >
            <RankingBox />
          </motion.div>
          <div
            style={{ marginBottom: isMobile ? -120 : -40 }}
            className="col-12 mt-3 d-flex align-items-center justify-content-between"
          >
            <Button
              onClick={() => {
                onFriendlyMatch();
                dispatch(CloseArenaDialog());
              }}
              variant="wide"
              style={{ height: 53 }}
              size={isMobile ? "small" : "medium"}
              className="bg-100 gap-2 px-3"
            >
              <CustomIcon icon="person-plus" width={20} type="svg" />
              {t("dashboard.actions.friendlyMatch")}
            </Button>
            <Button
              size={isMobile ? "small" : "medium"}
              onClick={() => setVideoDialog(true)}
              style={{ height: 53 }}
              variant="wide"
              className="bg-100 gap-2 px-3 "
            >
              <CustomIcon
                icon="youtube-icon"
                width={20}
                height={15}
                type="svg"
              />
              {t("dashboard.actions.learnArena")}
            </Button>
          </div>
        </div>
      )}
      <Dialog
        open={videoDialog}
        onClose={() => setVideoDialog(false)}
        title={t("dashboard.actions.watchVideo")}
        className="p-0 position-relative"
        size="lg"
        noFooter
        backdropClose
      >
        <div
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          className="position-absolute  0 d-flex align-items-center justify-content-center"
        >
          <CircularProgress />
        </div>
        <div className="position-relative z-10 ">
          <YouTube
            videoId="U13anbsDa5g"
            style={{ height: 350, width: "100%", marginBottom: -40 }}
            iframeClassName="w-100 h-100"
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ArenaDashboard;
